/**
 * Schema.org structured data для всего сайта
 * Поддержка индексации поисковыми системами и LLM
 */

// Основная информация об организации
export const OrganizationSchema = {
  "@context": "https://schema.org",
  "@type": "AutoDealer",
  "@id": "https://firstclass-avto.ru/#organization",
  "name": "FIRST CLASS",
  "alternateName": "FIRST CLASS — Автосалон премиум-класса",
  "description": "Международный импорт люксовых автомобилей под ключ. Полный цикл: поиск, проверка, доставка и таможня.",
  "url": "https://firstclass-avto.ru",
  "logo": "https://firstclass-avto.ru/logo.png",
  "foundingDate": "2015",
  "telephone": "+7-929-670-70-70",
  "email": "info@firstclass-avto.ru",
  "address": {
    "@type": "PostalAddress",
    "addressLocality": "Москва",
    "addressCountry": "RU"
  },
  "areaServed": {
    "@type": "Country",
    "name": "Россия"
  },
  "sameAs": [
    "https://auto.ru/dealer/firstclass/",
  ],
  "knowsAbout": [
    "Импорт автомобилей",
    "Растаможка автомобилей",
    "Премиальные автомобили",
    "Международные автомобильные сделки",
    "Mercedes-Benz",
    "BMW",
    "Porsche",
    "Rolls-Royce",
    "Lamborghini",
    "Ferrari"
  ],
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Услуги по импорту автомобилей",
    "itemListElement": [
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Импорт из Германии",
          "description": "Покупка и доставка автомобилей из Германии"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Импорт из ОАЭ",
          "description": "Покупка и доставка автомобилей из ОАЭ и Дубая"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Импорт из США",
          "description": "Покупка автомобилей на аукционах США"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Импорт из Кореи",
          "description": "Покупка и доставка автомобилей из Южной Кореи"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Импорт из Китая",
          "description": "Покупка электромобилей и авто из Китая"
        }
      }
    ]
  }
};

// WebSite schema для поисковых систем
export const WebSiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "FIRST CLASS — Автосалон премиум-класса",
  "url": "https://firstclass-avto.ru",
  "description": "Международный импорт люксовых автомобилей под ключ. Полный цикл: поиск, проверка, доставка и таможня.",
  "publisher": {
    "@id": "https://firstclass-avto.ru/#organization"
  },
  "potentialAction": {
    "@type": "SearchAction",
    "target": "https://firstclass-avto.ru/search?q={search_term_string}",
    "query-input": "required name=search_term_string"
  }
};

// Breadcrumb schema generator
export const generateBreadcrumbSchema = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": items.map((item, index) => ({
    "@type": "ListItem",
    "position": index + 1,
    "name": item.name,
    "item": item.url
  }))
});

// HowTo schema для процесса покупки
export const HowToSchema = {
  "@context": "https://schema.org",
  "@type": "HowTo",
  "name": "Как купить автомобиль из-за рубежа",
  "description": "Пошаговое руководство по покупке и импорту автомобиля в Россию",
  "totalTime": "P6W",
  "estimatedCost": {
    "@type": "MonetaryAmount",
    "currency": "RUB",
    "value": "500000"
  },
  "step": [
    {
      "@type": "HowToStep",
      "position": 1,
      "name": "Формирование стратегии",
      "text": "Обсуждаем ваши требования, бюджет и предпочтения по автомобилю",
      "url": "https://firstclass-avto.ru/deal#step1"
    },
    {
      "@type": "HowToStep",
      "position": 2,
      "name": "Проверка автомобиля",
      "text": "Проверяем историю, документы и техническое состояние автомобиля",
      "url": "https://firstclass-avto.ru/deal#step2"
    },
    {
      "@type": "HowToStep",
      "position": 3,
      "name": "Финансовая модель",
      "text": "Рассчитываем полную стоимость: автомобиль, доставка, растаможка",
      "url": "https://firstclass-avto.ru/deal#step3"
    },
    {
      "@type": "HowToStep",
      "position": 4,
      "name": "Организация сделки",
      "text": "Проводим переговоры и организуем безопасный международный расчёт",
      "url": "https://firstclass-avto.ru/deal#step4"
    },
    {
      "@type": "HowToStep",
      "position": 5,
      "name": "Логистика",
      "text": "Организуем доставку и страхование автомобиля",
      "url": "https://firstclass-avto.ru/deal#step5"
    },
    {
      "@type": "HowToStep",
      "position": 6,
      "name": "Таможенное оформление",
      "text": "Проходим растаможку, оплачиваем пошлины, получаем ЭПТС",
      "url": "https://firstclass-avto.ru/deal#step6"
    },
    {
      "@type": "HowToStep",
      "position": 7,
      "name": "Передача владельцу",
      "text": "Передаём автомобиль с полным пакетом документов",
      "url": "https://firstclass-avto.ru/deal#step7"
    }
  ]
};

// LocalBusiness schema
export const LocalBusinessSchema = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "FIRST CLASS",
  "image": "https://firstclass-avto.ru/showroom.jpg",
  "telephone": "+7-929-670-70-70",
  "email": "info@firstclass-avto.ru",
  "address": {
    "@type": "PostalAddress",
    "addressLocality": "Москва",
    "addressCountry": "RU"
  },
  "openingHours": "Mo-Fr 10:00-20:00, Sa 11:00-18:00",
  "priceRange": "$$$$"
};

// Компонент для вставки всех глобальных схем
export const GlobalSchemas = () => (
  <>
    <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(OrganizationSchema) }} />
    <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(WebSiteSchema) }} />
    <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(HowToSchema) }} />
    <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(LocalBusinessSchema) }} />
  </>
);
